import { Slider } from "@mui/material";
import PageTitleSubtitle from "../PageTitleSubTitle";

export default function FieldSlider({
  fieldTitle,
  fieldSubtitle,
  fieldName,
  handleValueChange,
  fieldValue,
  customMinWidth,
}) {
  return (
    <div className="w-full flex justify-between items-center my-2 gap-2">
      <div>
        <PageTitleSubtitle
          useFieldTitleStyle
          useEventTitleStyle
          title={fieldTitle}
          subtitle={fieldSubtitle}
        />
      </div>
      <Slider
        name={fieldName}
        aria-label="Always visible"
        defaultValue={fieldValue ?? 80}
        step={10}
        valueLabelDisplay="on"
        onChange={handleValueChange}
        size="small"
        sx={{ minWidth: customMinWidth ?? "250px" }}
      />
    </div>
  );
}
